import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import useUserContext from 'Context/UserContext';
import MissionControlCanaryRoot from './Root';

const ModularMissionControlCanary = (props) => {
  const { householdResource } = useSimpleHousehold();
  const { userResource } = useUserContext();

  if (!(userResource && householdResource)) {
    return null;
  }

  return (
    <MissionControlCanaryRoot {...props} />
  );
};

export default ModularMissionControlCanary;
